import React, { useState } from "react";
import { useSelector } from "react-redux";
import Input from "../../input/Input";
import SearchDropdown from "../../input/SearchDropdown";
import Button from "../../input/Button";
import { getOtherRefSearchDropdown } from "../../../api/keyvalue";
import { updateEmployeeDates } from "../../../api/employeeModificationApi";
import useUserCompany from "../../../hooks/useUserCompany";
import { toast } from "react-toastify";

const EmployeeDateChange = ({ selectedIds, onSuccess, onClose }) => {
  const user = useSelector((state) => state.user);
  const company = useUserCompany();
  const companyId = company?.comId;

  const [empExpiryDate, setEmpExpiryDate] = useState("");
  const [empGsExpiry, setEmpGsExpiry] = useState("");
  const [empPoliceExpiry, setEmpPoliceExpiry] = useState("");
  const [empAvcExpiry, setEmpAvcExpiry] = useState("");
  const [empInsuranceExpDate, setEmpInsuranceExpDate] = useState("");
  const [empInsuranceProvider, setEmpInsuranceProvider] = useState("");
  const [modificationRemark, setModificationRemark] = useState("");
  const [insuranceProviderReset, setInsuranceProviderReset] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validate = () => {
    const hasAtLeastOne =
      empExpiryDate ||
      empGsExpiry ||
      empPoliceExpiry ||
      empAvcExpiry ||
      empInsuranceExpDate ||
      empInsuranceProvider;

    if (!hasAtLeastOne) {
      toast.error("At least one field must be provided", {
        autoClose: 5000,
        containerId: "Modal",
      });
      return false;
    }

    return true;
  };
  const handleSubmit = async () => {
    if (!validate()) return;

    const request = {
      empId: selectedIds,
      empExpiryDate: empExpiryDate ? empExpiryDate : null,
      empGsExpiry: empGsExpiry ? empGsExpiry : null,
      empPoliceExpiry: empPoliceExpiry ? empPoliceExpiry : null,
      empAvcExpiry: empAvcExpiry ? empAvcExpiry : null,
      empInsuranceExpDate: empInsuranceExpDate ? empInsuranceExpDate : null,
      empInsuranceProvider: empInsuranceProvider ? empInsuranceProvider : null,
      modificationRemark: modificationRemark,
    };

    try {
      setIsSubmitting(true);
      const response = await updateEmployeeDates(
        request,
        user.username,
        companyId,
      );

      const allSuccess = response.every((r) => r.success);
      const anySuccess = response.some((r) => r.success);

      if (allSuccess) {
        toast.success("Employee dates updated successfully!", {
          autoClose: 5000,
          containerId: "Modal",
        });
        setTimeout(() => {
          onSuccess();
        }, 1000);
      } else if (anySuccess) {
        const failed = response.filter((r) => !r.success);
        console.log("Failed updates:", failed);
        toast.warning("Some employees failed to update. Please try again.", {
          autoClose: 5000,
          containerId: "Modal",
        });

        if (onSuccess) onSuccess();
      } else {
        toast.error("Update failed. Please try again.", {
          autoClose: 5000,
          containerId: "Modal",
        });
      }
    } catch (error) {
      console.log("Error updating employee dates", error);
      toast.error("An error occurred. Please try again.", {
        autoClose: 5000,
        containerId: "Modal",
      });
      setIsSubmitting(false);
    }
  };

  const handleReset = () => {
    setEmpExpiryDate("");
    setEmpGsExpiry("");
    setEmpPoliceExpiry("");
    setEmpAvcExpiry("");
    setEmpInsuranceExpDate("");
    setEmpInsuranceProvider("");
    setModificationRemark("");
    setInsuranceProviderReset(true);
  };

  return (
    <div>
      <form className="ui form">
        <div className="ui segment">
          <h4 className="ui dividing header">Change Expire Dates</h4>

          <div className="two fields">
            <Input
              label="Licence Expiry Date"
              type="date"
              value={empExpiryDate}
              onChange={(e) => {
                setEmpExpiryDate(e.target.value);
              }}
            />
            <Input
              label="GS Expiry"
              type="date"
              value={empGsExpiry}
              onChange={(e) => {
                setEmpGsExpiry(e.target.value);
              }}
            />
          </div>
          <div className="two fields">
            <Input
              label="Police Expiry"
              type="date"
              value={empPoliceExpiry}
              onChange={(e) => {
                setEmpPoliceExpiry(e.target.value);
              }}
            />
            <Input
              label="AVC Expiry"
              type="date"
              value={empAvcExpiry}
              onChange={(e) => {
                setEmpAvcExpiry(e.target.value);
              }}
            />
          </div>
          <div className="two fields">
            <Input
              label="Insurance Expiry Date"
              type="date"
              value={empInsuranceExpDate}
              onChange={(e) => {
                setEmpInsuranceExpDate(e.target.value);
              }}
            />
            <SearchDropdown
              label="Insurance Provider"
              reset={insuranceProviderReset}
              setReset={setInsuranceProviderReset}
              clearable={true}
              onClear={() => {
                setEmpInsuranceProvider("");
              }}
              api={getOtherRefSearchDropdown}
              apiDependency={{
                type: "stakeholder_type",
                value: "Supplier",
                param1: "Insurance Provider",
              }}
              onResultSelect={(data) => {
                setEmpInsuranceProvider(data);
              }}
            />
          </div>
          <div className="one field">
            <Input
              label="Remark"
              placeholder="Enter modification remark"
              value={modificationRemark}
              onChange={(e) => setModificationRemark(e.target.value)}
            />
          </div>
          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
          >
            <Button
              template="reset"
              onClick={handleReset}
              disabled={isSubmitting}
            />
            <Button
              template="submit"
              onClick={handleSubmit}
              loading={isSubmitting}
              disabled={isSubmitting}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default EmployeeDateChange;
